import { MsalAuthProvider } from 'react-aad-msal';

// import { IAccountInfo } from 'react-aad-msal';


export class PortalState {
    private static _instance: PortalState;

    private constructor() {
        
    }

    public static get Instance() {
        // Do you need arguments? Make it a regular static method instead.
        return this._instance || (this._instance = new this());
    }

    public authProvider: MsalAuthProvider;
    public groups: BwGroup[];
    public videos: BwVideo[];

    public ApiEndpoint: string;
}

export class BwGroup {
    public GroupId: string;
    public GroupName: string;
    public Groupdescription: string;
}

export class BwVideo {
    public id: string;
    public Title: string;
    public src: string;
}

export const _PortalState = PortalState.Instance;


// WEBPACK FOOTER //
// ./src/helpers/state.ts